import OperationsRepository from '@/libs/customAxios/operationAxios'

const customerDetailsSettingResource = '/admin/settings/security'

export default {
  getCustomerDetailsSetting() {
    return OperationsRepository.get(`${customerDetailsSettingResource}`)
  },
  updateCustomerDetailsSetting(payload) {
    return OperationsRepository.put(`${customerDetailsSettingResource}`, payload)
  },
}
